import { render, staticRenderFns } from "./CustomisationNavigationPage.vue?vue&type=template&id=19f5f246&"
import script from "./CustomisationNavigationPage.vue?vue&type=script&lang=js&"
export * from "./CustomisationNavigationPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomisationNavigationPage.vue?vue&type=style&index=0&id=19f5f246&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports